<div class="version">v{{ appVersion }}<br>{{commitHash}}</div>
